import React from "react";
import { useSelector } from "react-redux";
import FloatingReactionItem from "./FloatingReactionItem/FloatingReactionItem";

export default function FloatingReaction() {
  const reactions = useSelector((state) => state.reactions.list);
  const localAvatar = useSelector((state) => state.auth.localAvatar);

  return (
    <>
      {reactions.map((reaction) => {
        const isSelf =
          String(reaction.sender) === String(localAvatar?.id);

        return (
          <FloatingReactionItem
            key={reaction.id}
            reaction={reaction}
            isSelf={isSelf}
          />
        );
      })}
    </>
  );
}
